import GenericVModel from '@components/mixins/genericVModel'

export default {
  name: 'EditBlockCheckBox',
  mixins: [GenericVModel],
  // props: {},
  // methods: {}
}
